import { render, staticRenderFns } from "./DashboardSection.vue?vue&type=template&id=2ccfe268&scoped=true"
import script from "./DashboardSection.vue?vue&type=script&lang=js"
export * from "./DashboardSection.vue?vue&type=script&lang=js"
import style0 from "./DashboardSection.vue?vue&type=style&index=0&id=2ccfe268&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ccfe268",
  null
  
)

export default component.exports